// extracted by mini-css-extract-plugin
var _1 = "b7_SI";
export { _1 as "bodyContainer" }
